import { render, staticRenderFns } from "./KYC1Auth.vue?vue&type=template&id=297cb012&scoped=true"
import script from "./KYC1Auth.vue?vue&type=script&lang=js"
export * from "./KYC1Auth.vue?vue&type=script&lang=js"
import style0 from "./KYC1Auth.vue?vue&type=style&index=0&id=297cb012&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297cb012",
  null
  
)

export default component.exports